// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from "react-i18next";
// Parts
import Table, { TableApiParamsType, ToolbarType } from "../../components/Table";
// Engine
import { axiosAPI } from "../../../engine/config/axios";

const ProjectTrackedTimeEmployees:FC<{ toolbar: ToolbarType }> = (props) => {
  const { toolbar } = props;
  const projectId = document.getElementById('projectId');
  const params = new URLSearchParams(window.location.search)

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
    ot: params.get('ot'),
    date_from: params.get('date_from'),
    date_to: params.get('date_to'),
    filters: loadOptions?.filter,
    sort: loadOptions?.sort,
    project: projectId?.dataset.project_id,
    type: 'projectTrackedTimeByEmployee',
      ...pageParams
    });

  return <Table
    toolbar={toolbar}
    api={axiosAPI.projectTimes.projectsTrackedTime}
    gridName="projectTrackedTimeByEmployee"
    apiParams={apiParams}
  />;
}

function ProjectTrackedTimeEmployeesPortal({ id }: { id: string }) {
  const { t } = useTranslation();

  const toolbar = [{
    type: 'title',
    value: t('Team')
  }];
  const Root = document.getElementById(id);
  return Root ? createPortal(<ProjectTrackedTimeEmployees toolbar={toolbar} />, Root) : null;
}

export default ProjectTrackedTimeEmployeesPortal;
